module.exports = __webpack_public_path__ + "f2d020494771f811658bbc91c2f26cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/cushion.png
// module id = 765
// module chunks = 0